module.exports = __webpack_public_path__ + "static/media/f_hairstyle_straight_short_front_vector.3e4c77eb.svg";